/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespSimilarItem_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespComplementaryItemsGrid_viewer$ref: FragmentReference;
export type PdpRespComplementaryItemsGrid_viewer = {|
  +$fragmentRefs: PdpRespSimilarItem_viewer$ref,
  +$refType: PdpRespComplementaryItemsGrid_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespComplementaryItemsGrid_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '64a3ea2779157c349a659e1aa0dcd062';
module.exports = node;
